import React, { Fragment, useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import UserPanel from './userPanel';
import FooterPanel from './footerPanel';
import { MENUITEMS } from '../../../components/common/sidebar-component/menu';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import configDB from '../../../data/customizer/config';
import API from '../../../services/API';
import { Tool } from 'react-feather';
import { toast } from 'react-toastify';

const Sidebar = () => {
  const [margin, setMargin] = useState(0);
  const [width, setWidth] = useState(0);
  const [hideLeftArrowRTL, setHideLeftArrowRTL] = useState(true);
  const [hideRightArrowRTL, setHideRightArrowRTL] = useState(true);
  const [hideRightArrow, setHideRightArrow] = useState(true);
  const [hideLeftArrow, setHideLeftArrow] = useState(true);
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 1024 : false
  );
  const [mainmenu, setMainMenu] = useState({
    mainmenu: [...MENUITEMS],
  });

  const wrapper = configDB.data.settings.sidebar.wrapper;
  const layout = useSelector((content) => content.Customizer.layout);
  const { t } = useTranslation();
  const location = useLocation();

  const styles = {
    sidebarShell: {
      background:
        'radial-gradient(circle at top left, rgba(239,68,68,0.08), transparent 34%), linear-gradient(180deg, #ffffff 0%, #f8fafc 48%, #eef2f7 100%)',
      borderRight: '1px solid #e5e7eb',
      boxShadow: '14px 0 45px rgba(15,23,42,0.08)',
      height: '100vh',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    },
    brandWrap: {
      height: 72,
      flex: '0 0 72px',
      display: 'flex',
      alignItems: 'center',
      padding: '18px 18px 12px',
      background: 'transparent',
    },
    brandLink: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      width: '100%',
      padding: '8px 6px', // ↓ reduce padding
      borderRadius: 12,   // ↓ less round
      color: '#0f172a',
      textDecoration: 'none',

      // REMOVE THESE:
      background: 'transparent',
      border: 'none',
      boxShadow: 'none',
    },
    logo: {
      width: 36,  // ↓ from 42
      height: 36,
      borderRadius: 10,
      padding: 3,
      border: '1px solid #e5e7eb',
      boxShadow: '0 4px 12px rgba(15,23,42,0.06)', // lighter
    },
    brandTitle: {
      fontSize: 14,
      fontWeight: 800,
      letterSpacing: '-0.01em',
    },

    brandSub: {
      marginTop: 2,
      fontSize: 10,
      letterSpacing: '0.08em',
    },
    sidebarInner: {
      background: 'transparent',
      padding: '0 14px 18px',
      flex: '1 1 auto',
      minHeight: 0,
      overflowY: 'auto',
      overflowX: 'hidden',
      WebkitOverflowScrolling: 'touch',
    },
    userWrap: {
      marginBottom: 14,
      padding: 14,
      borderRadius: 24,
      background: '#ffffff',
      border: '1px solid #e5e7eb',
      boxShadow: '0 12px 32px rgba(15,23,42,0.05)',
    },

    menu: {
      padding: '6px 0 14px',
      listStyle: 'none',
    },

    menuItem: {
      margin: '5px 0',
      listStyle: 'none',
    },

    sidebarTitle: {
      margin: '20px 12px 9px',
      color: '#94a3b8',
      fontSize: 10,
      fontWeight: 900,
      letterSpacing: '0.16em',
      textTransform: 'uppercase',
    },

    linkBase: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      minHeight: 48,
      padding: '12px 14px',
      borderRadius: 17,
      color: '#475569',
      textDecoration: 'none',
      background: 'transparent',
      transition: 'all 0.2s ease',
      border: '1px solid transparent',
      cursor: 'pointer',
    },

    linkActive: {
      color: '#ffffff',
      background:
        'linear-gradient(135deg, #ef4444 0%, #b91c1c 100%)',
      boxShadow: '0 14px 35px rgba(239,68,68,0.24)',
      border: '1px solid rgba(239,68,68,0.2)',
    },

    activeRail: {
      position: 'absolute',
      left: -14,
      top: 12,
      bottom: 12,
      width: 4,
      borderRadius: 999,
      background: '#ef4444',
    },

    iconWrap: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 22,
      height: 22,
      flex: '0 0 22px',
    },

    menuText: {
      flex: 1,
      minWidth: 0,
      fontSize: 13,
      fontWeight: 800,
      letterSpacing: '-0.01em',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },

    arrow: {
      marginLeft: 'auto',
      color: '#94a3b8',
      transition: 'transform 0.2s ease',
    },

    arrowActive: {
      color: '#ffffff',
      transform: 'rotate(90deg)',
    },

    submenu: {
      display: 'none',
      margin: '7px 0 8px 18px',
      padding: '7px 0 7px 12px',
      borderLeft: '1px solid #e2e8f0',
      listStyle: 'none',
    },

    submenuOpen: {
      display: 'block',
    },

    submenuLink: {
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      minHeight: 38,
      padding: '9px 12px',
      borderRadius: 13,
      color: '#64748b',
      textDecoration: 'none',
      fontSize: 12,
      fontWeight: 750,
      transition: 'all 0.2s ease',
      cursor: 'pointer',
    },

    submenuLinkActive: {
      color: '#b91c1c',
      background: '#fef2f2',
    },

    subDot: {
      width: 7,
      height: 7,
      borderRadius: 999,
      background: '#cbd5e1',
      flex: '0 0 7px',
    },

    subDotActive: {
      background: '#ef4444',
      boxShadow: '0 0 0 5px rgba(239,68,68,0.13)',
    },

    footerWrap: {
      marginTop: 18,
      paddingTop: 14,
      borderTop: '1px solid #e5e7eb',
    },

    arrowButton: {
      color: '#334155',
      background: '#ffffff',
      border: '1px solid #e5e7eb',
      borderRadius: 999,
      cursor: 'pointer',
      boxShadow: '0 8px 20px rgba(15,23,42,0.08)',
    },
  };

  const closeMobileSidebar = () => {
    if (!isMobile) return;

    document.querySelector('.page-main-header')?.classList.remove('open');
    document.querySelector('.page-sidebar')?.classList.remove('open');
    document.querySelector('.page-body-wrapper')?.classList.remove('sidebar-open');

    document.body.classList.remove('sidebar-open');
    document.body.classList.remove('offcanvas');
  };

  const fetchCustomAttendanceEnabled = () => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      token: localStorage.getItem('token'),
    };

  };

  const updateMenuActiveState = (pathname) => {
    setMainMenu((prev) => {
      const clonedMenu = prev.mainmenu.map((item) => {
        const clonedItem = {
          ...item,
          active: false,
          children: item.children
            ? item.children.map((child) => ({
              ...child,
              active: false,
              children: child.children
                ? child.children.map((subChild) => ({
                  ...subChild,
                  active: false,
                }))
                : undefined,
            }))
            : undefined,
        };

        if (clonedItem.path === pathname) {
          clonedItem.active = true;
        }

        if (clonedItem.children) {
          clonedItem.children = clonedItem.children.map((child) => {
            if (child.path === pathname) {
              clonedItem.active = true;
              return { ...child, active: true };
            }

            if (child.children) {
              const updatedSubChildren = child.children.map((subChild) => {
                if (subChild.path === pathname) {
                  clonedItem.active = true;
                  child.active = true;
                  return { ...subChild, active: true };
                }

                return subChild;
              });

              return {
                ...child,
                children: updatedSubChildren,
              };
            }

            return child;
          });
        }

        return clonedItem;
      });

      return { mainmenu: clonedMenu };
    });
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 1024;
      setIsMobile(mobile);
      setWidth(Math.max(window.innerWidth - 310, 0));
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    const timeout = setTimeout(() => {
      const elmnt = document.getElementById('myDIV');

      if (!elmnt) return;

      const menuWidth = elmnt.offsetWidth;

      if (menuWidth > window.innerWidth) {
        setHideRightArrow(false);
        setHideLeftArrowRTL(false);
      } else {
        setHideRightArrow(true);
        setHideLeftArrowRTL(true);
      }
    }, 500);

    fetchCustomAttendanceEnabled();

    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    updateMenuActiveState(location.pathname);
  }, [location.pathname]);

  const toggleNavActive = (item) => {
    if (item.type === 'link') closeMobileSidebar();

    setMainMenu((prev) => {
      const updatedMenu = prev.mainmenu.map((menuItem) => {
        const isClickedMain = menuItem.title === item.title;

        if (menuItem.type === 'sub' || menuItem.children) {
          return {
            ...menuItem,
            active: isClickedMain ? !menuItem.active : false,
          };
        }

        return {
          ...menuItem,
          active: isClickedMain,
        };
      });

      return { mainmenu: updatedMenu };
    });
  };

  const toggleChildActive = (parentItem, childItem) => {
    if (childItem.type === 'link') closeMobileSidebar();

    setMainMenu((prev) => {
      const updatedMenu = prev.mainmenu.map((menuItem) => {
        if (menuItem.title !== parentItem.title) return menuItem;

        const updatedChildren = menuItem.children?.map((child) => ({
          ...child,
          active:
            child.title === childItem.title
              ? child.type === 'sub'
                ? !child.active
                : true
              : false,
        }));

        return {
          ...menuItem,
          active: true,
          children: updatedChildren,
        };
      });

      return { mainmenu: updatedMenu };
    });
  };

  const scrollToRight = () => {
    const elmnt = document.getElementById('myDIV');
    if (!elmnt) return;

    const menuWidth = elmnt.offsetWidth;
    const temp = menuWidth + margin;

    if (temp < menuWidth) {
      setMargin(-temp);
      setHideRightArrow(true);
    } else {
      setMargin((current) => current - width);
      setHideLeftArrow(false);
    }
  };

  const scrollToLeft = () => {
    if (margin >= -width) {
      setMargin(0);
      setHideLeftArrow(true);
    } else {
      setMargin((current) => current + width);
      setHideRightArrow(false);
    }
  };

  const scrollToLeftRTL = () => {
    if (margin <= -width) {
      setMargin((current) => current - width);
      setHideLeftArrowRTL(true);
    } else {
      setMargin((current) => current - width);
      setHideRightArrowRTL(false);
    }
  };

  const scrollToRightRTL = () => {
    const temp = width + margin;

    if (temp === 0) {
      setMargin(temp);
      setHideRightArrowRTL(true);
    } else {
      setMargin((current) => current + width);
      setHideRightArrowRTL(false);
      setHideLeftArrowRTL(false);
    }
  };

  const getMenuStyle = () => {
    if (wrapper !== 'horizontal_sidebar') {
      return {
        ...styles.menu,
        margin: '0px',
      };
    }

    if (layout === 'rtl') {
      return {
        ...styles.menu,
        marginRight: `${margin}px`,
      };
    }

    return {
      ...styles.menu,
      marginLeft: `${margin}px`,
    };
  };

  const getLinkStyle = (active) => ({
    ...styles.linkBase,
    ...(active ? styles.linkActive : {}),
  });

  const getSubmenuStyle = (open) => ({
    ...styles.submenu,
    ...(open ? styles.submenuOpen : {}),
  });

  const getSubmenuLinkStyle = (active) => ({
    ...styles.submenuLink,
    ...(active ? styles.submenuLinkActive : {}),
  });
  return (
    <Fragment>
      <div className="page-sidebar" style={styles.sidebarShell}>
        <div className="main-header-left d-none d-lg-block" style={styles.brandWrap}>
          <Link to="/dashboard" style={styles.brandLink}>
            <img
              src="https://imgur.com/kEzgWVd.png"
              alt="MYSP.AI"
              style={styles.logo}
            />

            <div>
              <strong style={styles.brandTitle}>MYSP.AI</strong>
              <span style={styles.brandSub}> Platform</span>
            </div>
          </Link>
        </div>

        <div className="sidebar custom-scrollbar" style={styles.sidebarInner}>
          <div style={styles.userWrap}>
            <UserPanel />
          </div>

          <ul id="myDIV" className="sidebar-menu" style={getMenuStyle()}>
            <li
              className={`left-arrow ${layout === 'rtl'
                ? hideLeftArrowRTL
                  ? 'd-none'
                  : ''
                : hideLeftArrow
                  ? 'd-none'
                  : ''
                }`}
              style={styles.arrowButton}
              onClick={
                wrapper === 'horizontal_sidebar' && layout === 'rtl'
                  ? scrollToLeftRTL
                  : scrollToLeft
              }
            >
              <i className="fa fa-angle-left" />
            </li>

            {mainmenu?.mainmenu?.map((menuItem, i) => {
              const Icon = menuItem.icon;
              const isActive = !!menuItem.active;

              return (
                <li
                  key={`${menuItem.title}-${i}`}
                  className={isActive ? 'active' : ''}
                  style={styles.menuItem}
                >
                  {menuItem.sidebartitle ? (
                    <div style={styles.sidebarTitle}>
                      {menuItem.sidebartitle}
                    </div>
                  ) : null}

                  {menuItem.type === 'sub' ? (
                    <a
                      href="#"
                      className="sidebar-header"
                      style={getLinkStyle(isActive)}
                      onMouseEnter={(e) => {
                        if (!isActive) {
                          e.currentTarget.style.background = '#ffffff';
                          e.currentTarget.style.borderColor = '#e5e7eb';
                          e.currentTarget.style.boxShadow = '0 10px 26px rgba(15,23,42,0.06)';
                          e.currentTarget.style.color = '#0f172a';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isActive) {
                          e.currentTarget.style.background = 'transparent';
                          e.currentTarget.style.borderColor = 'transparent';
                          e.currentTarget.style.boxShadow = 'none';
                          e.currentTarget.style.color = '#475569';
                        }
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        toggleNavActive(menuItem);
                      }}
                    >
                      {isActive && <span style={styles.activeRail} />}

                      <span style={styles.iconWrap}>
                        {Icon && <Icon size={19} strokeWidth={2.3} />}
                      </span>

                      <span style={styles.menuText}>
                        {t(menuItem.title)}
                      </span>

                      <i
                        className="fa fa-angle-right"
                        style={{
                          ...styles.arrow,
                          ...(isActive ? styles.arrowActive : {}),
                        }}
                      />
                    </a>
                  ) : null}

                  {menuItem.type === 'link' ? (
                    <Link
                      to={menuItem.path}
                      className="sidebar-header"
                      style={getLinkStyle(isActive)}
                      onClick={() => toggleNavActive(menuItem)}
                    >
                      {isActive && <span style={styles.activeRail} />}

                      <span style={styles.iconWrap}>
                        {Icon && <Icon size={19} strokeWidth={2.3} />}
                      </span>

                      <span style={styles.menuText}>
                        {t(menuItem.title)}
                      </span>

                      {menuItem.children ? (
                        <i
                          className="fa fa-angle-right"
                          style={{
                            ...styles.arrow,
                            ...(isActive ? styles.arrowActive : {}),
                          }}
                        />
                      ) : null}
                    </Link>
                  ) : null}

                  {menuItem.children ? (
                    <ul
                      className={`sidebar-submenu ${isActive ? 'menu-open' : ''}`}
                      style={getSubmenuStyle(isActive)}
                    >
                      {menuItem.children.map((childrenItem, index) => {
                        const canShow =
                          childrenItem.title !== 'Portal User' ||
                          localStorage.getItem('role') === '1';

                        if (!canShow) return null;

                        const childActive = !!childrenItem.active;

                        return (
                          <li
                            key={`${childrenItem.title}-${index}`}
                            className={childActive ? 'active' : ''}
                            style={{ listStyle: 'none', margin: '3px 0' }}
                          >
                            {childrenItem.type === 'sub' ? (
                              <a
                                href="#"
                                style={getSubmenuLinkStyle(childActive)}
                                onClick={(e) => {
                                  e.preventDefault();
                                  toggleChildActive(menuItem, childrenItem);
                                }}
                              >
                                <span
                                  style={{
                                    ...styles.subDot,
                                    ...(childActive ? styles.subDotActive : {}),
                                  }}
                                />
                                <span>{t(childrenItem.title)}</span>
                                <i className="fa fa-angle-right pull-right" />
                              </a>
                            ) : null}

                            {childrenItem.type === 'link' ? (
                              <Link
                                to={childrenItem.path}
                                style={getSubmenuLinkStyle(childActive)}
                                onClick={() =>
                                  toggleChildActive(menuItem, childrenItem)
                                }
                              >
                                <span
                                  style={{
                                    ...styles.subDot,
                                    ...(childActive ? styles.subDotActive : {}),
                                  }}
                                />
                                <span>{t(childrenItem.title)}</span>
                              </Link>
                            ) : null}
                          </li>
                        );
                      })}
                    </ul>
                  ) : null}
                </li>
              );
            })}

            <li
              className={`right-arrow ${layout === 'rtl'
                ? hideRightArrowRTL
                  ? 'd-none'
                  : ''
                : hideRightArrow
                  ? 'd-none'
                  : ''
                }`}
              style={styles.arrowButton}
              onClick={
                wrapper === 'horizontal_sidebar' && layout === 'rtl'
                  ? scrollToRightRTL
                  : scrollToRight
              }
            >
              <i className="fa fa-angle-right" />
            </li>
          </ul>

          <div style={styles.footerWrap}>
            <FooterPanel />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Sidebar;